import deepmerge from 'deepmerge';
import { FragmentConfig } from '@/config/types';
import config from './default';
import { DeepPartial } from './deeppartial';

export const tenantConfig: DeepPartial<FragmentConfig> = {
  apiParams: {
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'OttoversandAt',
        clientShortId: 'ovat',
        locale: 'de-AT',
        localeApi: 'de',
        localesToSwitch: ['de-AT'],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.ottoversand.at',
      },
    },
  },
  headerInformation: {
    de: {
      description:
        'OTTO - der Online Shop für Mode, Schuhe, Möbel und mehr. Gratis Versand ab 75 € | bequem online shoppen und auf Rechnung oder Raten kaufen!',
      title: 'OTTO Online Shop',
      canonical: 'https://www.ottoversand.at',
      robots: 'index,follow',
    },
  },
  tracking: {
    schemaOrgOrganisation: {
      areaServed: 'AT',
      email: 'webmaster@ottoversand.at',
      hoursAvailable: '7 Tage die Woche von 07:00 bis 22:00 Uhr (natürlich auch an Feiertagen)',
      logo: `/assets/logos/${config?.global?.values?.FRAGMENT_COMPANYID}/logo.svg`,
      name: 'Otto',
      productSupported: '',
      sameAs: ['"https://www.facebook.com/ottoversand"', '"https://www.instagram.com/ottoversand"'],
      telephone: '+43-316-606-888',
      url: 'https://www.ottoversand.at',
      potentialAction: {
        target: 'https://www.ottoversand.at/s/',
      },
    },
    values: {
      googleSiteVerification: 'OTOyZGCNE4oOQ_91TV_2c3DeGnpNEsqffPwgTlli_Ds',
      msvalidate01: '313E2E7F8778335B4C29FD80AAAE5469',
      siteName: '@EmpirieCom-OttoversandAT',
      soastaId: 'TWCKT-SC956-AY2DD-K9G3Y-24R2M',
    },
  },
};

export default deepmerge(config, tenantConfig) as FragmentConfig;
